import { TAddress, TGeoLocation } from '@components/types';
import { Atoms } from "@recoil/constants";
import { atom, selector } from 'recoil';

const localStorage = typeof window !== `undefined` ? window.localStorage : null

export const internalAddressState = atom < TAddress > ({
    key: Atoms.InternalAddress,
    default: JSON.parse(localStorage?.getItem(Atoms.Address.toString()) || "{}"),
});

export const internalGeoLocationState = atom < TGeoLocation > ({
    key: Atoms.internalGeoPosition,
    default: JSON.parse(localStorage?.getItem(Atoms.geoposition.toString()) || "{}"),
});

// export const addressState = atom<TAddress> ({
//     key: Atoms.Address,
//     default: null, 
// });
export const addressState = selector({
    key: Atoms.Address,
    get: ({ get }) => get(internalAddressState),
    set: ({ set }, newValue) => {
        set(internalAddressState, newValue);
        localStorage?.setItem(Atoms.Address.toString(), JSON.stringify(newValue));
    },
});

export const geoLocationState = selector({
    key: Atoms.geoposition,
    get: ({ get }) => get(internalGeoLocationState),
    set: ({ set }, newValue) => {
        set(internalGeoLocationState, newValue);
        localStorage?.setItem(Atoms.geoposition.toString(), JSON.stringify(newValue));
    },
});

